/**
 * Polish has three plural forms, and a panel that ignores them writes "2
 * źródło nie działa" on the one screen somebody reads under pressure.
 *
 * `one` for 1, `few` for 2–4 (but not 12–14), `many` for the rest — which is
 * also the form the teens and every multiple of ten take.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) return one
  const tens = count % 100
  const units = count % 10
  if (units >= 2 && units <= 4 && !(tens >= 12 && tens <= 14)) return few
  return many
}
